import React, { useState } from 'react';
import { message, Button, Upload, Menu, Dropdown, Modal } from 'antd';
import { ApiHelpers } from '../../../helpers';
import { UploadOutlined } from '@ant-design/icons';

import ImgCrop from 'antd-img-crop';

function UploadCustomizationImageQR(props) {
    const { restaurantId, customization, setCustomization } = props;
    const [modalVisible, setModalVisible] = useState(false);
    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow.document.write(image.outerHTML);
    };

    const uploadPropsCoverImage = {
        name: 'file',
        action: ApiHelpers.uploadRestaurantCustomizationImageQR(restaurantId),
        method: 'PUT',
        headers: {
            authorization: 'authorization-text',
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                //console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                message.success(`${info.file.name} file uploaded successfully`);
                setCustomization({
                    ...customization,
                    qrImagePath: info.file.response.qrImagePath,
                });
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onPreview: onPreview,
    };
    const onDeleteRestaurantCoverImage = () => {
        ApiHelpers.deleteRestaurantCustomizationImageQR(restaurantId).then(
            (response) => {
                setCustomization({
                    ...customization,
                    qrImagePath: null,
                });
                message.success('Imagine stearsa!');
            },
            (error) => {
                console.log(error);
                message.error('Eroare!');
            }
        );
    };
    const menuCoverImage = (
        <Menu>
            <Menu.Item>
                <a onClick={onDeleteRestaurantCoverImage}>Sterge</a>
            </Menu.Item>
            <Menu.Item>
                <ImgCrop rotate aspect={2 / 3} minZoom={0.2} cropperProps={{ restrictPosition: false }}>
                    <Upload {...uploadPropsCoverImage}>
                        <a onClick={(e) => e.preventDefault()}>Modifica</a>
                    </Upload>
                </ImgCrop>
            </Menu.Item>
        </Menu>
    );

    return (
        <>
            {customization.qrImagePath ? (
                <Dropdown overlay={menuCoverImage}>
                    <a className="imgUpload-preview" onClick={(e) => e.preventDefault()}>
                        <img src={ApiHelpers.getImageLink(customization.qrImagePath)} className="uploadedImage portrait" />
                    </a>
                </Dropdown>
            ) : (
                <ImgCrop rotate aspect={2 / 3} modalTitle="Previzualizare">
                    <Upload {...uploadPropsCoverImage}>
                        <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                </ImgCrop>
            )}
        </>
    );
}

export default UploadCustomizationImageQR;
